import React from "react";
import { Phone } from "lucide-react";
import { ICON_STROKE } from "../../ui/icon";
import { toTitleCase } from "../../../utils/titleCase";

const PublicEmergencyContacts = ({ primaryContact, otherPhones, onCall, t }) => {
  const contacts = [
    primaryContact ? { ...primaryContact, role: t("public.primaryContactLabel") } : null,
    ...(otherPhones || []).map((p) => ({ ...p, role: p.name })),
  ].filter(Boolean);

  if (!contacts.length) return null;

  return (
    <section className="pub-contacts" aria-labelledby="pub-contacts-title">
      <h2 id="pub-contacts-title" className="pub-section-title">
        {t("public.emergencyContacts")}
      </h2>
      <div className="pub-contacts__list">
        {contacts.map((contact, idx) => (
          <div key={contact.id || `${contact.name}-${idx}`} className="pub-contacts__row">
            <div className="pub-contacts__meta">
              <span className="pub-contacts__name">{toTitleCase(contact.name)}</span>
              {contact.role && contact.role !== contact.name && (
                <span className="pub-contacts__role">{toTitleCase(contact.role)}</span>
              )}
            </div>
            <button
              type="button"
              className="pub-contacts__call"
              onClick={() => onCall?.(contact)}
            >
              <Phone size={15} strokeWidth={ICON_STROKE} aria-hidden />
              {t("public.callNow")}
            </button>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PublicEmergencyContacts;
